<template>
  <div class="page" v-if="can('others.carousel')">
    <h2 class="accent--text">
      <v-icon color="primary" class="ml-3" large>mdi-view-carousel-outline</v-icon>
      العارض الديناميكي
      <back-button />
    </h2>
    <hr class="my-5 header-divider" />

    <!-- RECORD INFO DIALOG -->
    <record-info />

    <!-- CREATE FROM -->
    <record-form @update="fetchRecords()" />

    <!-- UPDATE / NEW RECORD -->
    <div class="mb-3 mt-9 text-left">
      <v-btn
        v-if="can('article.store')"
        color="primary"
        elevation="0"
        @click="SHOW_RECORD_FORM()"
      >
        اضافة مادة أو خبر للعارض
        <v-icon class="mr-2">mdi-plus</v-icon>
      </v-btn>
    </div>

    <!-- TABLE -->
    <v-data-table
      item-key="id"
      class="elevation-1"
      :loading="table.loading"
      :headers="table.headers"
      :items="records"
      loading-text="جاري تحميل البيانات"
      no-data-text="لا يوجد بيانات"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
    >
      <!-- TYPE -->
      <template v-slot:item.type="{ item }">
        <v-chip small color="success" v-if="item.sub_section_id">مقال</v-chip>
        <v-chip small color="info" v-else>خبر</v-chip>
      </template>
      <!-- CONTROLS -->
      <template v-slot:item.controls="{ item }">
        <v-btn
          small
          icon
          color="info"
          class="mx-2"
          :href="previewLink(item.id)"
          target="_blank"
        >
          <v-icon>mdi-eye</v-icon>
        </v-btn>

        <v-btn
          small
          outlined
          color="warning darken-2"
          class="mx-2"
          @click="hide(item)"
        >
          إخفاء من العارض
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>


<script>
import { mapState, mapMutations } from 'vuex';
import RecordForm from './RecordForm';
import RecordInfo from '@/views/articles/RecordInfo';

export default {
  name: 'carousel',
  components: { RecordForm, RecordInfo },


  data: function () {
    return {
      table: {
        headers: [
          {
            value: 'id',
            text: 'مسلسل'
          },
          {
            value: 'title_text',
            text: 'العنوان'
          },
          {
            value: 'type',
            text: 'نوع المادة'
          },
          {
            value: 'published_date',
            text: 'تاريخ النشر'
          },
          {
            value: 'created_at',
            text: 'تاريخ الإضافة'
          },
          {
            value: 'controls',
            text: 'اعدادات'
        }
        ],
        loading: false
      }
    }
  },


  created() {
    this.fetchRecords();
  },


  computed: {
    ...mapState('carousel', ['records'])
  },


  methods: {
    ...mapMutations('articles', ['SHOW_RECORD_INFO']),
    ...mapMutations('carousel', ['SHOW_RECORD_FORM']),

    previewLink(articleId) {
      return `${process.env.VUE_APP_WEBSITE_BASE_URL}/guest-admin/articles-unpublished?article_id=${articleId}`
    },

    fetchRecords() {
      this.table.loading = true;

      this.$store.dispatch('carousel/fetchRecords')
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر جلب البيانات, يرجي التأكد من حالة الشبكة',
            color: 'accent'
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    },

    fetchRecord(recordId) {
      this.table.loading = true;

      this.$store.dispatch('articles/fetchRecord', { id: recordId })
        .then(() => {
          this.SHOW_RECORD_INFO();
        })
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر جلب البيانات, يرجي التأكد من حالة الشبكة',
            color: 'accent'
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    },

    async hide(selectedRecord) {
      const confirmMessageParams = [
        `إخفاء المادة رقم ${selectedRecord.id}!`,
        `هل أنت متأكد من إخفاء المادة ${selectedRecord.title_text} من العارض الديناميكي؟`,
        { color: 'warning darken-2' }
      ];
      if (!await this.$root.$confirm(...confirmMessageParams)) return;

      this.table.loading = true;

      this.$store.dispatch('carousel/removeSlide', {
        recordId: selectedRecord.id,
        recordType: selectedRecord.sub_section_id ? 'article' : 'news'
      })
      .then(() => {
        this.$bus.$emit('showSnackbar', {
          text: 'تم إخفاء المادة بنجاح',
          color: 'success'
        });
      })
      .catch((error) => {
        this.$bus.$emit('showSnackbar', {
          text: 'تعذر إخفاء المادة',
          color: 'accent'
        });
      })
      .finally(() => {
        this.table.loading = false;
      });
    }
  }
}
</script>
